import { render, staticRenderFns } from "./ToastificationAvatar.vue?vue&type=template&id=bc4dac82&scoped=true&"
import script from "./ToastificationAvatar.vue?vue&type=script&lang=js&"
export * from "./ToastificationAvatar.vue?vue&type=script&lang=js&"
import style0 from "./ToastificationAvatar.vue?vue&type=style&index=0&id=bc4dac82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4dac82",
  null
  
)

export default component.exports